module.exports = {
    API_URL: 'https://web.api-ukbatteriesnetwork.org',
    RAW_S3_STORAGE_URL: 'https://ktn-csbs-media.s3-eu-west-1.amazonaws.com',
    TINY_API_KEY: 'i1fjms8n28s9r9l925zkvgcss324273abrhgqe3l6lbetqbn',
};
